export const SELL_SEATING_PREFERENCE = 'SellSeatingPreference';
export const SELL_SEATING_BESIDE = 'SellSeatingBeside';
export const SELL_SEAT_MAP_SEGMENT_NEW = 'SellSeatMapSegmentNew';
export const SELL_SEAT_MAP_SEGMENT = 'SellSeatMapSegment';
export const SELL_SEAT_MAP_NO_OPTION = 'NO_OPTION';
export const AISLE = 'AISLE';
export const WINDOW = 'WINDOW';
export const BESIDE = 'BESIDE';
export const NO_OPTION = 'NO_OPTION';
export const SEATING_PREFERENCE_OPTIONS = {
  SELL_SEATING_PREFERENCE,
  SELL_SEATING_BESIDE,
  SELL_SEAT_MAP_SEGMENT_NEW,
  SELL_SEAT_MAP_SEGMENT
};
export const SEATING_PREFERENCE_VALUES = {
  AISLE,
  WINDOW,
  BESIDE,
  NO_OPTION
};
export const BULKHEAD = 'BULKHEAD';
export const LEG_SPACE = 'LEG_SPACE';
export const BASSINET = 'BASSINET';
export const FRONT_OF_CABIN = 'FRONT_OF_CABIN';
export const ELECTRONIC_CONNECTION = 'ELECTRONIC_CONNECTION';
export const SUITABLE_FOR_ADT_WITH_INF = 'SUITABLE_FOR_ADT_WITH_INF';
export const ECONOMY_COMFORT = 'ECONOMY_COMFORT';
export const NORMAL = 'NORMAL';
export const seatCharacteristics = {
  BULKHEAD,
  LEG_SPACE,
  BASSINET,
  FRONT_OF_CABIN,
  ELECTRONIC_CONNECTION,
  SUITABLE_FOR_ADT_WITH_INF,
  ECONOMY_COMFORT,
  NORMAL
};
//# sourceMappingURL=constants.js.map